import {forwardRef, memo, ReactNode} from 'react';
import {DownArrow, DropdownInput} from './DropDown.styled';
import RoundInput from '@components/Buttons/RoundInput';
import {Shadow} from '@styles/reusable';

interface IDropDown {
  onClick?: any;
  className?: string;
  title?: string;
  open: boolean;
  children: ReactNode;
}

export const DropDown = forwardRef<HTMLDivElement, IDropDown>(({ onClick, className = '', title = '', open, children }: IDropDown, ref) => {
  return (
    <RoundInput title={title} className={className} ref={ref}>
      <DropdownInput onClick={onClick}>
        {children}
        <DownArrow open={open} />
      </DropdownInput>
      <Shadow size={2}></Shadow>
    </RoundInput>
  );
});

export default memo(DropDown);
